import { render, staticRenderFns } from "./CreateSugestionModal.vue?vue&type=template&id=65699e56&scoped=true&"
import script from "./CreateSugestionModal.vue?vue&type=script&lang=js&"
export * from "./CreateSugestionModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateSugestionModal.vue?vue&type=style&index=0&id=65699e56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65699e56",
  null
  
)

export default component.exports